import { useEffect, useState } from 'react'

interface FloatingAdvertHook {
  showAdvert: boolean;
  handleCloseAdvert: () => void;
}

const LOCAL_STORAGE_KEY = 'floatingAdvert'
const TIME_TO_STORE = 5 * 60 * 1000 // 5 mins

export const useFloatingAdvert = (): FloatingAdvertHook => {
  const [showAdvert, setShowAdvert] = useState(false)

  useEffect(() => {
    const currentTime = new Date().getTime()
    const advertEndTime = localStorage.getItem(LOCAL_STORAGE_KEY)

    if (!advertEndTime || currentTime - +advertEndTime > TIME_TO_STORE) {
      setShowAdvert(true)
    }
  }, [])

  const handleCloseAdvert = (): void => {
    const currentTime = new Date().getTime()
    localStorage.setItem(LOCAL_STORAGE_KEY, String(currentTime))
    setShowAdvert(false)
  }

  return {
    showAdvert,
    handleCloseAdvert
  }
}
